(function(){
  "use strict";

  // Theme editor render lại section mỗi lần đổi setting -> dọn bản cũ trước.
  if (typeof window.__pumpkinOfferCleanup === "function") window.__pumpkinOfferCleanup();

  var nodes = document.querySelectorAll("script[data-pumpkin-config]");
  if (!nodes.length) return;
  var CFG;
  try { CFG = JSON.parse(nodes[nodes.length - 1].textContent); } catch(e){ return; }

  var isMobile = window.matchMedia("(max-width: 749px)").matches;
  if (isMobile && !CFG.mobile) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var KEY = "spookyOffer.v1";
  var DAY = 86400000;

  /* ---------- trạng thái lưu trên máy khách ----------
     localStorage ném lỗi trong chế độ ẩn danh của vài trình duyệt,
     nên mọi truy cập đều bọc try/catch và fallback về object rỗng. */
  function readState(){
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; }
    catch(e){ return {}; }
  }
  function writeState(s){
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch(e){}
  }
  var state = readState();

  /* Khách tắt popup không có nghĩa là bỏ cuộc ngay. Bí ngô còn quay lại cho tới
     khi bị tắt đủ minShows lần, sau đó mới nghỉ dài hideDays ngày.
     retryMinutes = 0 nghĩa là quay lại ngay ở lần xem trang kế tiếp. */
  var minShows = CFG.minShows > 0 ? CFG.minShows : 3;
  var retryMs  = (CFG.retryMinutes > 0 ? CFG.retryMinutes : 0) * 60000;
  var timesClosed = state.dismissCount || 0;

  if (!state.claimed && state.dismissedAt){
    var since = Date.now() - state.dismissedAt;
    if (timesClosed >= minShows){
      if (since < CFG.hideDays * DAY) return;   // đã tắt đủ số lần -> nghỉ dài
    } else if (since < retryMs){
      return;                                   // chưa đủ số lần, còn trong thời gian chờ
    }
  }

  function esc(s){
    return String(s == null ? "" : s)
      .replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;");
  }

  /* ---------- quả bí ngô ----------
     withArm = true: có nắp bật lên và cánh tay zombie trồi ra cầm tờ giấy.
     Cánh tay nằm trong một mask cắt ngang y=45, nên lúc nó còn tụt xuống trong
     quả bí thì bị che sạch, trồi lên tới đâu lộ ra tới đó - không cần xếp thứ
     tự vẽ phức tạp để giấu nó sau thân quả.
     Dùng <mask> chứ không dùng <clipPath> vì cả chuỗi SVG này được gán qua
     innerHTML: tên thẻ toàn chữ thường thì không phụ thuộc vào bảng chỉnh tên
     thẻ SVG của trình duyệt. */
  var SVG_N = 0;

  var FACE =
    '<path d="M38 51 L47 61 L29 61 Z"/>' +
    '<path d="M62 51 L71 61 L53 61 Z"/>' +
    '<path d="M50 62 L55 70 L45 70 Z"/>' +
    '<path d="M30 73 L36 79 L42 73 L48 79 L54 73 L60 79 L66 73 L70 74 ' +
      'Q62 89 50 89 Q38 89 30 74 Z"/>';

  var STEM = '<path d="M47 33 C46 25 44 20 40 16 C48 13 55 18 56 26 L56 34 Z" fill="#4E7A2E"/>';

  var LID =
    '<path d="M26 46 Q50 27 74 46 Q50 54 26 46 Z" fill="#F97316"/>' +
    '<path d="M26 46 Q50 54 74 46" fill="none" stroke="#C4460A" stroke-width="1.2"/>' +
    STEM;

  var ARM =
    // ống tay áo rách bươm
    '<path d="M41 50 L61 50 L61 39 L57 43.5 L53 38 L49 43.5 L45 39.5 L41 43 Z" fill="#3E3350"/>' +
    // cẳng tay
    '<path d="M44.5 45 C43.5 33 44.5 21 46 11 L58.5 10 C60 21 59.5 33 58.5 45 Z" fill="#8CA872"/>' +
    // mảng tối phía trong cho có khối
    '<path d="M44.5 45 C43.5 33 44.5 21 46 11 L50 10.7 C48.6 21 47.8 33 48.6 45 Z" fill="#6E8A56"/>' +
    // vết khâu chỉ
    '<g stroke="#57713F" stroke-width="0.9" stroke-linecap="round" fill="none">' +
      '<path d="M49.5 27 L56.5 26"/><path d="M51 25.4 L51 28.6"/><path d="M54 25 L54 28.2"/>' +
    '</g>' +
    // bàn tay nắm
    '<path d="M44 12 C43 5.5 46.5 1.5 52 1.5 L60 1.5 C64.5 1.5 66.5 5 65.5 9.2 ' +
      'L64.3 13.5 C63.5 16.5 60.5 17.6 57.5 17 L48 15.6 C45.6 15.2 44.2 14 44 12 Z" fill="#8CA872"/>' +
    '<g fill="none" stroke="#5F7A47" stroke-width="1.1" stroke-linecap="round">' +
      '<path d="M49.6 3.6 L49.2 15"/><path d="M55.4 2.6 L55.4 16"/><path d="M61 2.4 L61.5 16.4"/>' +
    '</g>';

  function pumpkinSVG(withArm){
    var uid = "pk-mask-" + (++SVG_N);
    var s = '<svg viewBox="0 0 100 100" width="100%" height="100%" ' +
      'xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" ' +
      'style="display:block;overflow:visible">';

    if (withArm){
      s += '<defs><mask id="' + uid + '" maskUnits="userSpaceOnUse" ' +
             'x="-40" y="-80" width="180" height="125">' +
             '<rect x="-40" y="-80" width="180" height="125" fill="#fff"/>' +
           '</mask></defs>';
    } else {
      s += STEM;
    }

    s += '<ellipse cx="31" cy="62" rx="20" ry="27" fill="#C4460A"/>' +
         '<ellipse cx="69" cy="62" rx="20" ry="27" fill="#C4460A"/>' +
         '<ellipse cx="41" cy="62" rx="22" ry="29" fill="#E45C10"/>' +
         '<ellipse cx="59" cy="62" rx="22" ry="29" fill="#E45C10"/>' +
         '<ellipse cx="50" cy="62" rx="25" ry="30" fill="#F97316"/>';

    if (withArm){
      s += '<ellipse cx="50" cy="41" rx="22" ry="7" fill="#2E1305"/>' +
           '<g mask="url(#' + uid + ')">' +
             '<g class="pk-arm"><g class="pk-arm-sway">' + ARM + '</g></g>' +
           '</g>';
    }

    s += '<g class="pk-face" fill="#FFD166">' + FACE + '</g>';

    if (withArm) s += '<g class="pk-lid">' + LID + '</g>';

    return s + '</svg>';
  }

  var CANDY =
    '<svg viewBox="0 0 24 24" width="19" height="19" fill="currentColor" ' +
      'aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="4.7"/>' +
      '<path d="M7.3 12 L2.4 8.2 L3.5 12 L2.4 15.8 Z"/>' +
      '<path d="M16.7 12 L21.6 8.2 L20.5 12 L21.6 15.8 Z"/>' +
    '</svg>';

  function skullSVG(px){
    return '<svg viewBox="0 0 24 24" width="' + px + '" height="' + px + '" ' +
      'fill="currentColor" aria-hidden="true" focusable="false">' +
      '<path d="M12 2.4c-4.8 0-8.1 3.3-8.1 7.6 0 2.5 1.2 4.3 2.6 5.3v2.3c0 .9.8 1.7 1.7 1.7h7.6' +
        'c.9 0 1.7-.8 1.7-1.7v-2.3c1.4-1 2.6-2.8 2.6-5.3 0-4.3-3.3-7.6-8.1-7.6z"/>' +
      '<g fill="#120E18">' +
        '<ellipse cx="8.9" cy="10.5" rx="2.05" ry="2.25"/>' +
        '<ellipse cx="15.1" cy="10.5" rx="2.05" ry="2.25"/>' +
        '<path d="M12 12.7 L13.15 15 L10.85 15 Z"/>' +
        '<rect x="9.5" y="16.4" width="1.1" height="2.9" rx=".4"/>' +
        '<rect x="11.45" y="16.4" width="1.1" height="2.9" rx=".4"/>' +
        '<rect x="13.4" y="16.4" width="1.1" height="2.9" rx=".4"/>' +
      '</g>' +
    '</svg>';
  }

  /* ---------- dựng DOM ---------- */
  var root = document.createElement("div");
  root.className = "pk-root pk-" + (CFG.position === "left" ? "left" : "right");
  root.style.setProperty("--pk-size", CFG.size + "px");
  root.style.setProperty("--pk-bottom", CFG.offsetBottom + "px");
  root.style.setProperty("--pk-bottom-mobile", CFG.offsetBottomMobile + "px");

  var btn = document.createElement("button");
  btn.type = "button";
  btn.className = "pk-btn";
  btn.setAttribute("aria-label", CFG.buttonAria);
  btn.innerHTML = '<span class="pk-glow"></span>' + pumpkinSVG(true) +
    '<span class="pk-note" aria-hidden="true">' +
      '<span class="pk-note-in">' + esc(CFG.noteLabel) + '</span>' +
    '</span>';

  var overlay = document.createElement("div");
  overlay.className = "pk-overlay";
  overlay.hidden = true;

  overlay.innerHTML =
    '<div class="pk-panel" role="dialog" aria-modal="true" aria-label="' + esc(CFG.heading) + '">' +
      '<button type="button" class="pk-close" aria-label="' + esc(CFG.closeAria) + '">&times;</button>' +
      '<div class="pk-mark">' + pumpkinSVG(false) + '</div>' +

      // 1. chọn Treat hay Trick
      '<div class="pk-view" data-view="choose">' +
        '<h2 class="pk-title">' + esc(CFG.heading) + '</h2>' +
        '<p class="pk-body">' + esc(CFG.body) + '</p>' +
        '<div class="pk-choices">' +
          '<button type="button" class="pk-choice pk-treat">' +
            CANDY + '<span>' + esc(CFG.treatLabel) + '</span></button>' +
          '<button type="button" class="pk-choice pk-trick">' +
            skullSVG(19) + '<span>' + esc(CFG.trickLabel) + '</span></button>' +
        '</div>' +
      '</div>' +

      // 2. lời nhắn + ô nhập mail (dùng chung cho cả hai nhánh)
      '<div class="pk-view" data-view="claim" hidden>' +
        '<div class="pk-scare" hidden>' + skullSVG(104) + '</div>' +
        '<h2 class="pk-title pk-claim-title"></h2>' +
        '<p class="pk-body pk-msg"></p>' +
        '<form class="pk-form" novalidate hidden>' +
          '<input type="email" class="pk-input" name="email" required ' +
            'autocomplete="email" inputmode="email" ' +
            'placeholder="' + esc(CFG.placeholder) + '" ' +
            'aria-label="' + esc(CFG.placeholder) + '">' +
          '<button type="submit" class="pk-submit">' + esc(CFG.buttonLabel) + '</button>' +
        '</form>' +
        '<p class="pk-error" role="alert" hidden></p>' +
        '<p class="pk-fine">' + esc(CFG.finePrint) + '</p>' +
      '</div>' +

      // 3. mã giảm giá
      '<div class="pk-view" data-view="code" hidden>' +
        '<h2 class="pk-title">' + esc(CFG.successHeading) + '</h2>' +
        '<p class="pk-body">' + esc(CFG.successBody) + '</p>' +
        '<div class="pk-code-row">' +
          '<code class="pk-code"></code>' +
          '<button type="button" class="pk-copy">' + esc(CFG.copyLabel) + '</button>' +
        '</div>' +
        '<p class="pk-timer"><span class="pk-timer-label">' + esc(CFG.timerLabel) + '</span> ' +
          '<b class="pk-clock">--:--</b></p>' +
        '<button type="button" class="pk-again" hidden>' + esc(CFG.againLabel) + '</button>' +
        '<p class="pk-fine">' + esc(CFG.finePrint) + '</p>' +
      '</div>' +
    '</div>';

  root.appendChild(btn);
  root.appendChild(overlay);
  document.body.appendChild(root);

  var panel      = overlay.querySelector(".pk-panel");
  var closeEl    = overlay.querySelector(".pk-close");
  var views      = overlay.querySelectorAll(".pk-view");
  var treatBtn   = overlay.querySelector(".pk-treat");
  var trickBtn   = overlay.querySelector(".pk-trick");
  var scareEl    = overlay.querySelector(".pk-scare");
  var claimTitle = overlay.querySelector(".pk-claim-title");
  var msgEl      = overlay.querySelector(".pk-msg");
  var form       = overlay.querySelector(".pk-form");
  var input      = overlay.querySelector(".pk-input");
  var submit     = overlay.querySelector(".pk-submit");
  var errEl      = overlay.querySelector(".pk-error");
  var codeEl     = overlay.querySelector(".pk-code");
  var copyEl     = overlay.querySelector(".pk-copy");
  var clockEl    = overlay.querySelector(".pk-clock");
  var timerEl    = overlay.querySelector(".pk-timer");
  var againEl    = overlay.querySelector(".pk-again");

  if (state.email) input.value = state.email;

  function setView(name){
    for (var i = 0; i < views.length; i++){
      views[i].hidden = views[i].getAttribute("data-view") !== name;
    }
  }

  /* ---------- gõ từng chữ ---------- */
  var typeTimer = null;

  function stopTyping(){
    if (typeTimer){ clearInterval(typeTimer); typeTimer = null; }
    msgEl.classList.remove("is-typing");
  }

  function typeInto(el, text, done){
    stopTyping();
    text = String(text || "");
    if (reduce || CFG.typeSpeed <= 0){
      el.textContent = text;
      done && done();
      return;
    }
    el.textContent = "";
    el.classList.add("is-typing");
    var i = 0;
    typeTimer = setInterval(function(){
      i++;
      el.textContent = text.slice(0, i);
      if (i >= text.length){
        stopTyping();
        done && done();
      }
    }, CFG.typeSpeed);
  }

  /* ---------- tiếng cười ----------
     Ưu tiên file mp3 do chủ store tải lên. Không có thì tổng hợp bằng Web Audio:
     một chuỗi tiếng bật ngắn tụt dần cao độ, đi qua bandpass cho ra âm sắc gần
     giọng, cộng thêm delay hồi tiếp cho vang và rợn. Đó là âm thanh máy, không
     phải giọng người thu thật. */
  var AC = window.AudioContext || window.webkitAudioContext;
  var stopAudio = null;

  function burst(ctx, dest, at, freq, len, vol){
    var o1 = ctx.createOscillator(); o1.type = "sawtooth";
    var o2 = ctx.createOscillator(); o2.type = "square";
    o1.frequency.setValueAtTime(freq * 1.06, at);
    o1.frequency.exponentialRampToValueAtTime(freq * 0.84, at + len);
    o2.frequency.setValueAtTime(freq * 0.5, at);
    o2.frequency.exponentialRampToValueAtTime(freq * 0.41, at + len);

    var bp = ctx.createBiquadFilter();
    bp.type = "bandpass";
    bp.frequency.setValueAtTime(700, at);
    bp.frequency.linearRampToValueAtTime(1220, at + len * 0.45);
    bp.frequency.linearRampToValueAtTime(640, at + len);
    bp.Q.value = 5.5;

    var g = ctx.createGain();
    g.gain.setValueAtTime(0.0001, at);
    g.gain.exponentialRampToValueAtTime(Math.max(0.02, vol), at + 0.014);
    g.gain.exponentialRampToValueAtTime(0.0001, at + len);

    o1.connect(bp); o2.connect(bp); bp.connect(g); g.connect(dest);
    o1.start(at); o2.start(at);
    o1.stop(at + len + 0.03); o2.stop(at + len + 0.03);
  }

  function synthLaugh(){
    if (!AC) return null;
    var ctx;
    try { ctx = new AC(); } catch(e){ return null; }
    if (ctx.state === "suspended" && ctx.resume) { try { ctx.resume(); } catch(e){} }

    var out = ctx.createGain();
    out.gain.value = 0.15;
    out.connect(ctx.destination);

    var dl = ctx.createDelay(1);
    dl.delayTime.value = 0.17;
    var fb = ctx.createGain(); fb.gain.value = 0.36;
    var wet = ctx.createGain(); wet.gain.value = 0.42;
    dl.connect(fb); fb.connect(dl); dl.connect(wet);
    out.connect(dl); wet.connect(ctx.destination);

    var t0 = ctx.currentTime + 0.04;
    var at = [0, .145, .29, .435, .62, .765, .91, 1.09, 1.27, 1.45, 1.67, 1.89];
    var end = 0;
    for (var i = 0; i < at.length; i++){
      var len = 0.13 + (i % 3 === 2 ? 0.06 : 0);
      burst(ctx, out, t0 + at[i], 300 * Math.pow(0.945, i), len, 0.9 - i * 0.028);
      end = at[i] + len;
    }
    burst(ctx, out, t0 + end + 0.14, 132, 0.55, 0.45);   // tiếng thở kết

    var total = end + 0.14 + 0.55 + 0.45;                // cộng đuôi vang
    stopAudio = function(){ try { ctx.close(); } catch(e){} };
    setTimeout(function(){ try { ctx.close(); } catch(e){} }, (total + 0.7) * 1000);
    return total;
  }

  function playLaugh(done){
    var finished = false;
    // Chốt chặn để luồng không kẹt nếu audio treo. Mốc 8 giây chỉ là tạm:
    // biết độ dài thật của file rồi thì nới ra, nếu không file dài hơn 8 giây
    // sẽ bị cắt ngang giữa tiếng cười.
    var guard = setTimeout(finish, 8000);

    function finish(){
      if (finished) return;
      finished = true;
      clearTimeout(guard);
      done();
    }

    if (CFG.laughUrl){
      try {
        var a = new Audio(CFG.laughUrl);
        a.volume = 0.85;
        a.addEventListener("ended", finish);
        a.addEventListener("error", useSynth);
        a.addEventListener("loadedmetadata", function(){
          if (isFinite(a.duration) && a.duration > 0){
            clearTimeout(guard);
            guard = setTimeout(finish, a.duration * 1000 + 1500);
          }
        });
        stopAudio = function(){ try { a.pause(); } catch(e){} };
        var p = a.play();
        if (p && p.catch) p.catch(useSynth);
        return;
      } catch(e){ /* rơi xuống synth */ }
    }
    useSynth();

    function useSynth(){
      if (finished) return;
      var dur = synthLaugh();
      if (dur == null){ setTimeout(finish, 800); return; }
      setTimeout(finish, dur * 1000 + 150);
    }
  }

  /* ---------- hai nhánh ---------- */
  function revealForm(){
    form.hidden = false;
    form.classList.add("is-in");
    if (!reduce) input.focus();
  }

  function onTreat(){
    setView("claim");
    scareEl.hidden = true;
    form.hidden = true;
    errEl.hidden = true;
    claimTitle.textContent = CFG.treatHeading;
    typeInto(msgEl, CFG.treatBody, revealForm);
  }

  function onTrick(){
    setView("claim");
    form.hidden = true;
    errEl.hidden = true;
    claimTitle.textContent = "";
    msgEl.textContent = "";

    // Cú hù có cả phần nhìn, để khách tắt tiếng vẫn thấy được chuyện gì xảy ra.
    scareEl.hidden = false;
    panel.classList.add("is-scaring");

    playLaugh(function(){
      panel.classList.remove("is-scaring");
      scareEl.hidden = true;
      claimTitle.textContent = CFG.trickHeading;
      typeInto(msgEl, CFG.trickBody, revealForm);
    });
  }

  treatBtn.addEventListener("click", onTreat);
  trickBtn.addEventListener("click", onTrick);

  /* ---------- đồng hồ giữ mã ---------- */
  var tick = null;

  function pad(n){ return (n < 10 ? "0" : "") + n; }

  function fmt(ms){
    var s = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60);   s -= m * 60;
    return h > 0 ? h + ":" + pad(m) + ":" + pad(s) : pad(m) + ":" + pad(s);
  }

  function renderClock(){
    var left = (state.reservedUntil || 0) - Date.now();
    if (left > 0){
      clockEl.textContent = fmt(left);
      timerEl.hidden = false;
      againEl.hidden = true;
    } else {
      timerEl.hidden = true;
      againEl.hidden = false;
      stopClock();
    }
  }
  function startClock(){
    stopClock();
    renderClock();
    tick = setInterval(renderClock, 1000);
  }
  function stopClock(){
    if (tick){ clearInterval(tick); tick = null; }
  }

  function showCode(){
    codeEl.textContent = state.code || CFG.code;
    copyEl.textContent = CFG.copyLabel;
    setView("code");
    startClock();
  }

  /* ---------- gửi email vào danh sách khách hàng Shopify ---------- */
  function subscribe(email){
    var fd = new FormData();
    fd.append("form_type", "customer");
    fd.append("utf8", "✓");
    fd.append("contact[email]", email);
    fd.append("contact[accepts_marketing]", "true");
    if (CFG.tag) fd.append("contact[tags]", CFG.tag);
    return fetch("/contact#contact_form", {
      method: "POST",
      body: fd,
      headers: { "Accept": "text/html" }
    });
  }

  var VALID = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  form.addEventListener("submit", function(ev){
    ev.preventDefault();
    var email = String(input.value || "").trim();

    errEl.hidden = true;
    if (!VALID.test(email)){
      errEl.textContent = CFG.errorEmail;
      errEl.hidden = false;
      input.focus();
      return;
    }

    submit.disabled = true;
    submit.textContent = CFG.sendingLabel;

    subscribe(email).then(function(){
      // Shopify trả về HTML của trang sau khi redirect. Kể cả khi email đã tồn tại
      // trong danh sách, request vẫn resolve - với khách thì cả hai đều là thành công,
      // nên chỉ lỗi mạng mới chặn họ lại.
      state.claimed = true;
      state.email = email;
      state.code = CFG.code;
      state.reservedUntil = Date.now() + CFG.reserveMinutes * 60000;
      delete state.dismissedAt;
      writeState(state);
      showCode();
      copyEl.focus && copyEl.focus();
    }).catch(function(){
      errEl.textContent = CFG.errorNetwork;
      errEl.hidden = false;
    }).then(function(){
      submit.disabled = false;
      submit.textContent = CFG.buttonLabel;
    });
  });

  copyEl.addEventListener("click", function(){
    var text = codeEl.textContent;
    function done(){
      copyEl.textContent = CFG.copiedLabel;
      setTimeout(function(){ copyEl.textContent = CFG.copyLabel; }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(text).then(done, fallback);
    } else fallback();

    function fallback(){
      var ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); done(); } catch(e){}
      document.body.removeChild(ta);
    }
  });

  againEl.addEventListener("click", function(){
    state.reservedUntil = Date.now() + CFG.reserveMinutes * 60000;
    writeState(state);
    startClock();
  });

  /* ---------- mở / đóng ---------- */
  var lastFocus = null;

  function focusable(){
    return Array.prototype.filter.call(
      panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
      function(el){ return !el.disabled && el.offsetParent !== null; }
    );
  }

  function open(){
    lastFocus = document.activeElement;
    if (state.claimed) showCode();
    else {
      setView("choose");
      scareEl.hidden = true;
      panel.classList.remove("is-scaring");
    }
    overlay.hidden = false;
    document.documentElement.classList.add("pk-locked");
    // đợi một frame để transition mở chạy được
    requestAnimationFrame(function(){ overlay.classList.add("is-open"); });
    var target = state.claimed ? copyEl : treatBtn;
    if (target && target.offsetParent !== null) target.focus();
    else { var f = focusable(); if (f.length) f[0].focus(); }
    document.addEventListener("keydown", onKey);
  }

  function close(dismissed){
    overlay.classList.remove("is-open");
    document.documentElement.classList.remove("pk-locked");
    document.removeEventListener("keydown", onKey);
    stopClock();
    stopTyping();
    if (stopAudio){ stopAudio(); stopAudio = null; }
    panel.classList.remove("is-scaring");
    scareEl.hidden = true;

    var hide = function(){ overlay.hidden = true; };
    if (reduce) hide(); else setTimeout(hide, 200);

    if (dismissed && !state.claimed){
      state.dismissedAt = Date.now();
      state.dismissCount = (state.dismissCount || 0) + 1;
      writeState(state);
      root.classList.add("pk-gone");
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(ev){
    if (ev.key === "Escape"){ ev.preventDefault(); close(true); return; }
    if (ev.key !== "Tab") return;
    var f = focusable();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (ev.shiftKey && document.activeElement === first){
      ev.preventDefault(); last.focus();
    } else if (!ev.shiftKey && document.activeElement === last){
      ev.preventDefault(); first.focus();
    }
  }

  btn.addEventListener("click", function(){ open(); });
  closeEl.addEventListener("click", function(){ close(true); });
  overlay.addEventListener("click", function(ev){
    if (ev.target === overlay) close(true);
  });

  /* ---------- xuất hiện sau N giây ---------- */
  var appearTimer = setTimeout(function(){
    root.classList.add("pk-in");
  }, Math.max(0, CFG.delay) * 1000);

  /* ---------- dọn dẹp ---------- */
  function cleanup(){
    clearTimeout(appearTimer);
    stopClock();
    stopTyping();
    if (stopAudio){ stopAudio(); stopAudio = null; }
    document.removeEventListener("keydown", onKey);
    document.removeEventListener("shopify:section:unload", onUnload);
    document.documentElement.classList.remove("pk-locked");
    if (root.isConnected) root.remove();
    window.__pumpkinOfferCleanup = null;
  }
  function onUnload(){ cleanup(); }

  document.addEventListener("shopify:section:unload", onUnload);
  window.__pumpkinOfferCleanup = cleanup;
})();
